import { STATES } from '../../constants/states'
import type { Address } from '../../types/address'

export function stateNameToCode(
  stateName: string,
  countryCode: Address['country'],
): string {
  if (!countryCode) return ''

  const states = STATES[countryCode] || []
  const state = states.find(
    ({ label }) => label.toLowerCase() === stateName.toLowerCase(),
  )

  return state ? state.value : ''
}
